import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import {
  TOP_OFFERS_TABLE_TITLE_SORT,
  TOP_OFFERS_TABLE_TITLE_WIDTHS,
  TOP_OFFERS_TABLE_TITLES,
} from "src/helpers/Constants";
import { StrategyTableSortType } from "src/helpers/Enums";
import WindowLabel from "./WindowLabel";

const TopOffersTable = (props) => {
  const [sortedList, setSortedList] = useState(props.list);

  useEffect(() => {
    setSortedList(props.list);
  }, [props.list]);

  const sortList = (index) => {
    const key = StrategyTableSortType[index];
    setSortedList(
      [...sortedList].sort((a, b) => {
        if (typeof a[key] === "string") {
          return a[key].localeCompare(b[key]);
        }
        return a[key] - b[key];
      })
    );
  };

  function formatRevenue(amount) {
    let formatted = amount.toFixed(2);
    formatted = formatted.replace(/\.00$/, "");
    return formatted;
  }

  return (
    <div className={"DashboardTableContainer"}>
      <div className="flex items-center justify-between gap-3">
        <div className={"DashboardTablesTitle"}>Top {props.title} Offers</div>
        <WindowLabel label="Last 1 month" />
      </div>
      {sortedList?.length > 0 ? (
        <div className={"w-full flex flex-col gap-3"}>
          <TableHeader
            titles={TOP_OFFERS_TABLE_TITLES}
            widths={TOP_OFFERS_TABLE_TITLE_WIDTHS}
            sort={TOP_OFFERS_TABLE_TITLE_SORT}
            sortList={sortList}
          />
          <div className="TableWrapper">
            <table className="Table">
              <tbody>
                {sortedList?.map((item, index) => (
                  <tr key={index} className="border-b h-[60px]">
                    <td
                      className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                      style={{ width: TOP_OFFERS_TABLE_TITLE_WIDTHS[0] }}
                    >
                      {item.name}
                    </td>
                    <td
                      className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                      style={{ width: TOP_OFFERS_TABLE_TITLE_WIDTHS[1] }}
                    >
                      ${formatRevenue(item.totalRevenue)}
                    </td>
                    <td
                      className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                      style={{ width: TOP_OFFERS_TABLE_TITLE_WIDTHS[2] }}
                    >
                      {parseInt(item.score)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className={"w-full h-full flex items-center justify-center"}>
          <div className={"flex flex-col items-center justify-center gap-4"}>
            <img
              alt={"Logo"}
              src={"/media/icons/rowsPurple.svg"}
              className={"w-12 h-12"}
            />
            <div className={"flex flex-col gap-1 justify-center items-center"}>
              <div className={"EmptyCaseTitle"}>
                No {props.title} Offers Available
              </div>
              <div className={"EmptyCaseDescription"}>
                Create new offers to see them ranked here.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default injectIntl(TopOffersTable);
